<template>
  <div class="boo-index">
    <div class="navigation">
      <div class="banner-slider" :style="sliderStyle">
        <img
          v-for="(img, index) in bannerImages"
          :key="index"
          :src="img"
          class="banner-img"
          alt="" />
      </div>
      <Header :class="{ hidden: isHidden }"></Header>>
      <!-- <div class="today-happy">
        <img src="@/assets/img/index/have_a_good_day.png" class="happy-img" alt="" />
        <img src="@/assets/img/index/all_good.png" class="all-good" alt="" />
      </div> -->
      <div class="change-banner">
        <div
          v-for="(item, index) in bannerImages"
          :key="index"
          class="change-line"
          :class="{ active: index === currentIndex }"
          @click="changeBanner(index)"></div>
      </div>
    </div>


    <div class="enterprise-core my600 fs45 fcF5F5F5">
      <div class="corporate-culture-bg AlimaBold fs230 fcB9B9B9">
          Corporate Culture
      </div>
      <div>
        <a href="#spirit" class="enterprise-spirit">
          企业精神
          <div class="read my400 fs16 fcB9B9B9">
            点击阅读
            <img src="@/assets/img/index/plus.png" class="plus-img" alt="" />
          </div>
        </a>
      </div>
      <div>
        <a href="#mission" class="corporate-mission">
          企业使命
          <div class="read my400 fs16 fcB9B9B9">
            点击阅读
            <img src="@/assets/img/index/plus.png" class="plus-img" alt="" />
          </div>
        </a>
      </div>
      <div>
        <a href="#mission" class="corporate-values">
          核心价值观
          <div class="read my400 fs16 fcB9B9B9">
            点击阅读
            <img src="@/assets/img/index/plus.png" class="plus-img" alt="" />
          </div>
          <div class="values-boo">
            <img src="@/assets/img/index/line1.png" class="values-boo-img" alt="" />
          </div>
        </a>
      </div>
      <div>
        <a href="#vision" class="corporate-vision">
          企业愿景
          <div class="read my400 fs16 fcB9B9B9">
            点击阅读
            <img src="@/assets/img/index/plus.png" class="plus-img" alt="" />
          </div>
        </a>
      </div>
    </div>


    <div class="spirit-module" id="spirit">
      <div class="spirit-left">
        <div class="title my600 fs60 fc000000">
          企业精神
          <div class="title-line"></div>
        </div>
        <div class="spirit-desc my400 fs32 fc000000">为往圣继绝学，为万世开太平。</div>
        <div class="spirit-sentence my400 fs22 fc000087">
          <!-- <div class="sentence">
            为天地立心，为生民立命，为往圣继绝学，为万世开太平
          </div> -->
        </div>
      </div>
      <div class="spirit-right">
        <img src="@/assets/img/index/corporate-spirit.png" class="spirit-img" alt="" />
        <div class="spirit-yellow" @wheel="onScroll">
          <div
            class="circle yellow"
            :style="{ transform: `translateY(${offsetY}px)` }"></div>
        </div>
      </div>
    </div>
    <div class="mission-values" id="mission">
      <div class="mission-blue" @wheel="onScroll">
        <div class="circle blue" :style="{ transform: `translateY(${offsetY}px)` }"></div>
      </div>
      <div class="boo-line2">
        <img src="@/assets/img/index/line2.png" class="line2-image" />
      </div>
      <div class="mission-left">
        <img src="@/assets/img/index/corporate-mission.png" class="mission-image" alt="" />
      </div>
      <div class="mission-right">
        <div class="title my600 fs60 fc000000">
          企业使命与核心价值观
          <div class="title-line"></div>
        </div>
        <div class="mission-desc my400 fs32 fc000000">
          安得广厦千万间，大庇天下寒士俱欢颜！
        </div>
      </div>
    </div>
    <div class="vision-module" id="vision">
      <div class="spirit-left">
        <div class="title my600 fs60 fc000000">
          企业愿景
          <div class="title-line"></div>
          <div class="title-line3">
            <img src="@/assets/img/index/line3.png" class="line3-img" alt="" />
          </div>
        </div>
        <div class="spirit-desc my400 fs32 fc000000">
          推进中华文化的伟大复兴。
        </div>
      </div>
      <div class="spirit-right">
        <img src="@/assets/img/index/corporate-vision.png" class="spirit-img" alt="" />
        <div class="spirit-blue" @wheel="onScroll">
          <div
            class="circle blue"
            :style="{ transform: `translateY(${offsetY}px)` }"></div>
        </div>
      </div>
    </div>
    <div class="major-event" id="events">
      <!-- 左侧年份列表 -->
      <div class="year-bamboo">
        <div class="year-main">
          <div class="year-inner" :style="transformStyle">
            <div
              class="year-item my600 fs26 fcFFFFFF"
              :class="{
                active: yearIndex === index,
                disabled: isPlaceholder(index),
              }"
              v-for="(item, index) in yearList"
              :key="index"
              @click="handleYearClick(index)">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="major-orange" @wheel="onScroll">
          <div
            class="circle orange"
            :style="{ transform: `translateY(${offsetY}px)` }"></div>
        </div>
      </div>
      <!-- 右侧事件内容 -->
      <div class="event-content">
        <div class="event-top fs54 fc000000">
          <div class="event-title my400">大事记</div>
          <div class="event-desc my600">
            <span class="my400">让我们</span>从现在开始一直走到未来
          </div>
          <div class="line4-img">
            <img src="@/assets/img/index/lin4.png" class="line4-img-image" alt="" />
          </div>
        </div>
        <!-- 动画包裹 event-bottom -->
        <transition name="slide-down" mode="out-in">
          <div class="event-bottom" v-if="!isPlaceholder(yearIndex)" :key="yearIndex">
            <div class="event-img">
              <img
                :src="eventList[yearIndex]?.img || ''"
                class="event-img-image"
                alt="" />
            </div>
            <div class="event-module">
              <div class="module-title my600 fs36 fc000000">
                {{ eventList[yearIndex]?.date }}
              </div>
              <div class="module-desc my400 fs26 fc000000">
                {{ eventList[yearIndex]?.desc }}
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="cooperate">
      <div class="cooperate-left">
        <div class="left-consult my600 fs80 fc000000">
          I Need To Consult
          <div class="line"></div>
        </div>
        <div class="left-email my400 fs22 fc000000">
          <div class="email-desc">媒体问询，招聘相关，广告合作，违规举报</div>
          <div class="email">interview@culturalroad.cn</div>
        </div>
      </div>
      <div class="cooperate-right">
        <img src="@/assets/img/index/logo3.png" class="logo3" alt="" />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script setup>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import { ref, computed, onMounted, onBeforeUnmount } from "vue";

  // 控制圆圈浮动的偏移值
  const offsetY = ref(0);

  const MAX_OFFSET = 80; // 最大浮动像素
  const STEP = 30; // 每次滚动浮动步长

  const onScroll = (event) => {
    if (event.deltaY > 0) {
      // 向下滚动
      offsetY.value = Math.min(offsetY.value + STEP, MAX_OFFSET);
    } else {
      // 向上滚动
      offsetY.value = Math.max(offsetY.value - STEP, -MAX_OFFSET);
    }
  };

  const isHidden = ref(false);
  let lastScrollTop = 0;

  const currentIndex = ref(0);
  const bannerImages = [
    require("@/assets/img/index/banner1.png"),
    require("@/assets/img/index/banner2.png"),
    require("@/assets/img/index/banner3.png"),
    require("@/assets/img/index/banner4.png"),
  ];
  const rawYearList = [
    "2025/4"
  ];
  const rawEventList = [
    {
      date: "2025年4月",
      desc: "杭州千里知行科技有限公司成立",
      img: require("@/assets/img/index/2025.4.png"),
    }
  ];

  const eventList = computed(() => {
    const list = [...rawEventList];
    for (let i = 0; i < paddingCount; i++) {
      list.unshift(null);
      list.push(null);
    }
    return list;
  });

  const paddingCount = 2;
  const yearList = computed(() => {
    const list = [...rawYearList];
    for (let i = 0; i < paddingCount; i++) {
      list.unshift(""); // 前面加空
      list.push(""); // 后面加空
    }
    return list;
  });

  const yearIndex = ref(paddingCount); // 默认选中第一个
  const itemHeight = 140;
  const visibleCount = 5;
  const centerIndex = Math.floor(visibleCount / 2);

  const transformStyle = computed(() => {
    const offset = (yearIndex.value - centerIndex) * itemHeight;
    return `transform: translateY(-${offset}px); transition: transform 0.5s ease`;
  });

  const handleYearClick = (index) => {
    yearIndex.value = index;
  };

  const isPlaceholder = (index) => {
    return index < paddingCount || index >= yearList.value.length - paddingCount;
  };

  const sliderStyle = computed(() => {
    return {
      transform: `translateX(-${currentIndex.value * 100}%)`,
    };
  });

  let timer = null;
  const startAutoPlay = () => {
    timer = setInterval(() => {
      currentIndex.value = (currentIndex.value + 1) % bannerImages.length;
    }, 5000);
  };

  const stopAutoPlay = () => {
    clearInterval(timer);
  };

  const changeBanner = (index) => {
    currentIndex.value = index;
    stopAutoPlay();
    startAutoPlay();
  };

  const handleScroll = () => {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop && currentScroll > 60) {
      isHidden.value = true; // 下滑：隐藏
    } else {
      isHidden.value = false; // 上滑：显示
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  };

  onMounted(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("wheel", onScroll);
    startAutoPlay();
  });

  onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("wheel", onScroll);
    stopAutoPlay();
  });
</script>
<style lang="less" scoped>
  .boo-index {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;

    .navigation {
      position: relative;
      width: 100%;
      height: 919px;
      overflow: hidden;

      .banner-slider {
        display: flex;
        width: 100%;
        height: 919px;
        transition: transform 0.5s ease-in-out;

        .banner-img {
          width: 100%;
          height: 919px;
          flex-shrink: 0;
          object-fit: cover;
        }
      }

      .today-happy {
        position: absolute;
        left: 166px;
        top: 708px;
        width: 477px;
        height: 114px;

        .happy-img {
          width: 100%;
          height: 100%;
        }

        .all-good {
          position: absolute;
          left: -30px;
          top: -18px;
          width: 58px;
          height: 58px;
        }
      }

      .change-banner {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 50px;
        z-index: 1;
        width: 60px;
        height: 30px;        
        
        .change-line {
          width: 10px;
          height: 20px;
          border-radius: 10px;
          background: white;
          cursor: pointer;
          transition: all 0.3s;
        }

        .change-line.active {
          height: 30px;
          background-color: #d3fea3;
        }
      }
    }


    .enterprise-core {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      margin-top: 127px;
      width: 100%;
      height: 230px;
      position: relative;

      .corporate-culture-bg {
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: -1;
        width: 100%;
        text-align: center;
        opacity: 0.1;
        white-space: nowrap;
        overflow: hidden;
      }

      .enterprise-spirit,
      .corporate-mission,
      .corporate-values,
      .corporate-vision {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        cursor: pointer;
        
        .values-boo {
          position: absolute;
          right: -190px;
          top: -182px;
          width: 144px;
          height: 323px;
          .values-boo-img {
            width: 100%;
            height: 100%;
            margin-top: -8px;
          }
        }

        .read {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-top: 20px;
          .plus-img {
            margin-left: 10px;
            width: 13px;
            height: 13px;
          }
        }
      }
    }


    .spirit-module {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 0 auto;
      margin-top: 65px;
      width: 1630px;
      height: 518px;

      .spirit-left {
        width: 555px;
        height: 346px;

        .title {
          position: relative;
          margin-top: 40px;
          .title-line {
            position: absolute;
            left: 0;
            bottom: 0px;
            z-index: -1;
            width: 249px;
            height: 24px;
            background: #d3fea3;
          }
        }

        .spirit-desc {
          margin-top: 80px;
        }

        .spirit-sentence {
          margin-top: 40px;
          width: 100%;

          .sentence {
            line-height: 50px;
          }
        }
      }

      .spirit-right {
        position: relative;
        width: 916px;
        height: 518px;

        .spirit-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }

        .spirit-yellow {
          position: absolute;
          right: -300px;
          top: -100px;
          z-index: -1;
          width: 500px;
          height: 500px;

          .circle {
            border-radius: 50%;
            opacity: 0.6;
            pointer-events: none;
            transition: transform 2.3s ease;
          }

          .yellow {
            width: 100%;
            height: 100%;
            background: radial-gradient(circle, rgba(255, 250, 229, 1));
          }
        }
      }
    }
 
    .mission-values {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      position: relative;
      margin: 0 auto;
      margin-top: 311px;
      width: 1630px;
      height: 518px;

      .mission-blue {
        position: absolute;
        left: -280px;
        top: -190px;
        width: 500px;
        height: 500px;

        .circle {
          border-radius: 50%;
          opacity: 0.6;
          pointer-events: none;
          transition: transform 2.3s ease;
        }

        .blue {
          width: 100%;
          height: 100%;
          background: radial-gradient(circle, rgba(0, 123, 255, 0.2));
        }
      }

      .boo-line2 {
        position: absolute;
        top: -300px;
        left: 320px;
        width: 350px;
        height: 190px;

        .line2-image {
          width: 100%;
          height: 100%;
        }
      }

      .mission-left {
        position: relative;
        width: 916px;
        height: 518px;
        border-radius: 10px 10px 10px 10px;
        background: #ffffff;
        overflow: hidden;
        background-color: rgba(243, 243, 243, 0.4);

        .mission-image {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .mission-right {
        margin: 0 0 0 73px;
        width: 600px;
        height: 217px;

        .title {
          position: relative;
          margin-top: 40px;

          .title-line {
            position: absolute;
            left: 0;
            bottom: 0px;
            z-index: -1;
            width: 600px;
            height: 24px;
            background: #d3fea3;
          }
        }

        .mission-desc {
          margin-top: 80px;
        }
      }
    }

    .vision-module {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 0 auto;
      margin-top: 311px;
      width: 1630px;
      height: 518px;

      .spirit-left {
        width: 520px;
        height: 346px;

        .title {
          position: relative;
          margin-top: 50px;

          .title-line {
            position: absolute;
            left: 0;
            bottom: 0px;
            z-index: -1;
            width: 249px;
            height: 24px;
            background: #d3fea3;
          }

          .title-line3 {
            position: absolute;
            left: -137px;
            top: -250px;
            width: 300px;
            height: 200px;

            .line3-img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .spirit-desc {
          margin-top: 80px;
        }
      }

      .spirit-right {
        position: relative;
        width: 916px;
        height: 518px;
        border-radius: 10px 10px 10px 10px;

        .spirit-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }

        .spirit-blue {
          position: absolute;
          right: -230px;
          top: -300px;
          width: 500px;
          height: 500px;
          z-index: -1;

          .circle {
            border-radius: 50%;
            opacity: 0.6;
            pointer-events: none;
            transition: transform 2.3s ease;
          }

          .blue {
            width: 100%;
            height: 100%;
            background: radial-gradient(circle, rgba(211, 254, 163, 0.3));
          }
        }
      }
    }

    .major-event {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 311px auto 0;
      // id: events;
      width: 1322px;
      height: 700px;

      /* event-bottom 平移动画 */
      .slide-down-enter-active,
      .slide-down-leave-active {
        transition: all 0.5s ease;
      }
      .slide-down-enter-from {
        transform: translateY(-30px);
        opacity: 0;
      }
      .slide-down-enter-to {
        transform: translateY(0);
        opacity: 1;
      }
      .slide-down-leave-from {
        transform: translateY(0);
        opacity: 1;
      }
      .slide-down-leave-to {
        transform: translateY(30px);
        opacity: 0;
      }

      .year-bamboo {
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: relative;
        width: 220px;
        height: 100%;
        background-image: url("@/assets/img/index/bamboo.png");
        background-repeat: no-repeat;
        background-position: 0, 0;
        background-size: 100% 100%;

        .year-main {
          width: 80px;
          height: 100%;
          box-sizing: border-box;
          overflow: hidden;
          position: relative;

          .year-inner {
            position: absolute;
            top: 0;
            left: 0;
          }

          .year-item {
            width: 100%;
            height: 140px;
            writing-mode: vertical-rl;
            text-align: center;
            cursor: pointer;
            transition: transform 0.3s, color 0.3s;

            &:nth-child(1) {
              margin-top: 0px !important;
            }
          }

          .year-item.disabled {
            pointer-events: none;
            opacity: 0;
            cursor: default;
          }
        }

        .major-orange {
          position: absolute;
          left: -300px;
          bottom: -100px;
          width: 500px;
          height: 500px;
          z-index: -1;

          .circle {
            border-radius: 50%;
            opacity: 0.6;
            pointer-events: none;
            transition: transform 2.3s ease;
          }

          .orange {
            width: 100%;
            height: 100%;
            background: radial-gradient(circle, rgba(255, 254, 176, 0.4));
          }
        }
      }

      .event-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        width: 1000px;
        height: 800px;

        .event-top {
          position: relative;
          width: 604px;
          height: 232px;

          .line4-img {
            position: absolute;
            right: -770px;
            top: -50px;
            width: 639px;
            height: 408px;
            .line4-img-image {
              width: 100%;
              height: 100%;
            }
          }
        }

        .event-bottom {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-top: 100px;
          width: 850px;
          height: 320px;
          background: #ffffff;
          box-shadow: 0px 0px 18px 0px #e2e2e2;
          border-radius: 20px 20px 20px 20px;

          .event-img {
            width: 50%;
            height: 100%;

            .event-img-image {
              width: 100%;
              height: 100%;
              border-radius: 20px 0px 0px 20px;
            }
          }

          .event-module {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            margin-left: 0;
            width: 50%;
            height: 320px;

            .module-desc {
              margin-top: 20px;
              margin-left: 40px;
              margin-right: 40px;
            }

            .module-title {
              margin-top: 30px;
              margin-left: 40px;
            }

            .module-change {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-self: flex-end;
              margin-top: 90px;
              width: 140px;
              height: 50px;

              .change-left,
              .change-right {
                width: 20px;
                height: 40px;
                cursor: pointer;

                .left-img,
                .right-img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }

    .cooperate {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 68px auto 0;
      width: 1731px;
      height: 700px;

      .cooperate-left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: -50px;
        width: 884px;
        height: 320px;

        .left-consult {
          position: relative;
          width: 390px;
          height: 190px;

          .line {
            position: absolute;
            left: 420px;
            bottom: 20px;
            width: 784px;
            height: 1px;
            background: #000000;
          }
        }

        .left-email {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;

          .email-desc {
            width: 522px;
            height: 70px;
            line-height: 70px;
            text-align: center;
            border-radius: 35px 35px 35px 35px;
            border: 1px solid #000000;
          }

          .email {
            margin-left: -40px;
            width: 392px;
            height: 70px;
            line-height: 70px;
            text-align: center;
            border-radius: 35px 35px 35px 35px;
            border: 1px solid #000000;
          }
        }
      }

      .cooperate-right {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 700px;
        height: 700px;

        .logo3 {
          margin-top: 149px;
          width: 271px;
          height: 300px;
        }
      }
    }
  }
</style>
